import theme from '../../themes/green';

const styles = {
  wrapper: {
    width: '100%',
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'space-between',
    alignItems: 'stretch',
  },
  organizations: {
    width: 240,
    background: theme.pallete.lightBackground,
    padding: '20px 0',
  },
  members: {},
  label: {
    fontSize: 14,
    fontWeight: 500,
    color: theme.pallete.background,
    height: 20,
    padding: '0 20px',
  },
  organization: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.pallete.background,
    height: 30,
    padding: '0 20px',
    cursor: 'pointer',
  },
  link: {
    color: theme.pallete.background,
    fontSize: 12,
    fontWeight: 400,
    height: 30,
    width: '100%',
    display: 'block',
    lineHeight: '30px',
    paddingLeft: '30px',
  },
  activeLink: {
    color: theme.pallete.color,
    backgroundColor: theme.pallete.background,
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/containers/Organization/styles.js